<div style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <h2>Non chiudere questa pagina, Trilly sta prendendo in carico l'invio</h2>
</div>
